<div *ngFor="let blog of blogEntries">
    <div [id]="blog.id" class="card p-3 mb-2">
        <div class="text-muted font-size-1 font-italic pb-2">{{ blog.createdAt | date:'EEEE, d MMM, yyyy' }}</div>
        <p class="mb-0" [innerHTML]="blog.text"></p>
    </div>
    <!--<a class="d-inline-block ml-3 mb-3" href="#">
        <span class="far fa-comments my-1"></span>
        Comment
    </a>
    <form class="mb-3 ml-4 d-none">
        <textarea rows="3" class="form-control mb-2"></textarea>
        <button type="reset" class="btn btn-primary btn-sm mr-2">Cancel</button>
        <button type="submit" class="btn btn-primary btn-sm">Post</button>
    </form>-->
</div>
<div>Count: {{ blogEntries.length }}</div>
